const SearchInputDocument = (props) => {
  const { name, label, type, tabIndex, onChange } = props;

  const TYPES = {
    CPF: "999.999.999-999",
    CNPJ: "99.999.999/9999-99",
  };
  const MAX_LENGTH = clear(TYPES.CNPJ).length;


  let value = clear(props.value);

  if (value) {
    value = applyMask(value, TYPES[getMask(value)]);
  }

  function onLocalChange(ev) {
    let value = clear(ev.target.value);
    const mask = getMask(value);

    let nextLength = value.length;

    if (nextLength > MAX_LENGTH) return;

    value = applyMask(value, TYPES[mask]);

    ev.target.value = value;

    onChange(ev, mask);
  }

  function getMask(value) {
    return value.length > 11 ? "CNPJ" : "CPF";
  }

  function applyMask(value, mask) {
    let result = "";

    let inc = 0;
    Array.from(value).forEach((letter, index) => {
      if (!mask[index + inc].match(/[0-9]/)) {
        result += mask[index + inc];
        inc++;
      }
      result += letter;
    });
    return result;
  }

  function clear(value) {
    return value && value.replace(/[^0-9]/g, "");
  }

  return (
    <>
      <div className='input-group'>
        <span className='input-group-text text-primary'>{label}</span>
        <input
          {...props}
          value={value}
          tabIndex={tabIndex}
          type={type || "text"}
          className='form-control'
          aria-label={label}
          placeholder={label}
          onChange={onLocalChange}
          aria-describedby={label}
          maxLength={18}
          name={name}
        />
      </div>
    </>
  );
};


export default SearchInputDocument;